module.exports = __webpack_public_path__ + "static/img/measurement03.974d65b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/measurements/measurement03.png
// module id = 16
// module chunks = 1